import { BaseXHR } from '@utils/axios';
import { take, fork, select, call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { isServer } from '@utils/helper';
import { isCustomDomain } from '@utils/domainHelper';
import { GET_DETAIL_PROJECT, GET_LIST_LANGUAGE } from './slice';

declare global {
  interface Window {
    mockApiData?: {
      project: any;
      languages: any[];
    };
  }
}

export function* watchAndLog() {
  while (true) {
    try {
      const styleConsole =
        'background: yellow; font-weight: bold; color: #40a9ff8c;';
      const action = yield take('*');
      const state = yield select();
      if (action.type !== '@@router/LOCATION_CHANGE') {
        console.group(action.type);
        console.log('%cBefore State', styleConsole, state);
        console.info('%cDispatching', styleConsole, action);
        console.log('%cNext State', styleConsole, state);
        console.groupEnd();
      }
    } catch {}
  }
}

// Helper function to get mock data (from JSON file)
function* getMockData() {
  try {
    // Try to get data from JSON file
    try {
      // Use axios to fetch the data
      const response = yield call(
        axios.get,
        `${process.env.NEXT_PUBLIC_BASE_URL}/mock-data/data.json`,
      );
      if (response.status === 200 && response.data) {
        return {
          project: response.data.project,
          languages: response.data.languages,
        };
      }
    } catch (error) {
      console.log('Failed to load mock-data.json');
    }
  } catch (error) {
    console.error('Error getting mock data:', error);
  }

  // Return empty data if everything fails
  return { project: null, languages: [] };
}

export function* getDetailProject({ payload }: any) {
  try {
    // Always try to use mock data first

    const mockData = yield call(getMockData);

    if (mockData.project) {
      console.log('Using mock data for project');
      yield put(GET_DETAIL_PROJECT.success(mockData.project));
      yield put(GET_LIST_LANGUAGE.success(mockData.languages));
      return;
    }
    // If useMockDataOnly flag is true, don't proceed to API calls
    if (payload.useMockDataOnly) {
      console.log('Mock data not found but useMockDataOnly is true');
      yield put(GET_DETAIL_PROJECT.failure());
      yield put(GET_LIST_LANGUAGE.failure());
      return;
    }

    // Fallback to real API calls if mock data is not available
    let url = '';

    // Determine if should use domain parameter based on current domain
    // Use domain mode ONLY if domain is NOT one of the main domains
    const shouldUseDomain = payload.domain && isCustomDomain(payload.domain);
    const domainParam = shouldUseDomain ? payload.domain : null;

    if (payload.isPayment) url = `project/getPaymentPublic?id=${payload.id}`;
    else if (payload.isPublic)
      url = `project/getPublic?${
        domainParam ? `domain=${domainParam}` : `slug=${payload.id}`
      }`;
    else url = `project/getPreview?slug=${payload.id}`;

    console.log(
      `[getDetailProject] Using ${domainParam ? 'domain' : 'slug'} mode:`,
      domainParam || payload.id,
    );

    const response = payload.isPublic
      ? yield call(BaseXHR.$get, url)
      : yield call(BaseXHR.$getWithAuth, url, {
          headers: {
            Authorization: `Bearer ${payload.token}`,
          },
        });

    const urlLanguage = 'language/gets';
    const responseLanguage = payload.isPublic
      ? yield call(BaseXHR.$get, urlLanguage)
      : yield call(BaseXHR.$getWithAuth, urlLanguage, {
          headers: {
            Authorization: `Bearer ${payload.token}`,
          },
        });

    const projectData = response.data.data;
    const languageData = responseLanguage?.data?.data?.docs || [];

    console.log('[getDetailProject] API Response:', {
      hasProjectData: !!projectData,
      projectTitle: projectData?.title,
      scenesCount: projectData?.scenes?.length || 0,
      languagesCount: languageData?.length || 0,
    });

    // Check if projectData is valid
    if (!projectData) {
      console.error(
        '[getDetailProject] API returned null/undefined project data',
      );
      yield put(GET_DETAIL_PROJECT.failure());
      yield put(GET_LIST_LANGUAGE.failure());
      return;
    }

    // Save API response to mock data file if successful (This is now handled by a separate script)
    // if (projectData && languageData.length > 0) {
    //   // Use call effect to handle the promise
    //   yield call(saveMockData, projectData, languageData);
    // }

    yield put(GET_DETAIL_PROJECT.success(projectData));
    yield put(GET_LIST_LANGUAGE.success(languageData));
    // if (response.data?.data?.scenes)
    //   yield put(actions.setListScene(response.data.data.scenes));
  } catch (err) {
    console.log(err);
    yield put(GET_DETAIL_PROJECT.failure());
    yield put(GET_LIST_LANGUAGE.failure());
  }
}

const homeSagas: any = [
  takeLatest(GET_DETAIL_PROJECT.TRIGGER, getDetailProject),
];

if (!isServer && process.env.NODE_ENV === 'development')
  homeSagas.push(fork(watchAndLog));

export default homeSagas;
